import { commonjsGlobal as u, getDefaultExportFromCjs as p } from "./index168.js";
import { __exports as s } from "./index169.js";
import "./index170.js";
import "./index171.js";
import "./index172.js";
import "./index173.js";
import { __exports as c } from "./index174.js";
import { __exports as d } from "./index175.js";
import { __exports as _ } from "./index176.js";
import { __exports as b } from "./index177.js";
(function(t) {
  var o = u && u.__importDefault || function(r) {
    return r && r.__esModule ? r : { default: r };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.htmlToDOM = t.domToReact = t.attributesToProps = t.Text = t.ProcessingInstruction = t.Element = t.Comment = void 0, t.default = l;
  var m = o(c);
  t.htmlToDOM = m.default;
  var i = o(d);
  t.attributesToProps = i.default;
  var a = o(_);
  t.domToReact = a.default;
  var e = b;
  Object.defineProperty(t, "Comment", { enumerable: !0, get: function() {
    return e.Comment;
  } }), Object.defineProperty(t, "Element", { enumerable: !0, get: function() {
    return e.Element;
  } }), Object.defineProperty(t, "ProcessingInstruction", { enumerable: !0, get: function() {
    return e.ProcessingInstruction;
  } }), Object.defineProperty(t, "Text", { enumerable: !0, get: function() {
    return e.Text;
  } });
  var f = { lowerCaseAttributeNames: !1 };
  function l(r, n) {
    if (typeof r != "string")
      throw new TypeError("First argument must be a string");
    return r ? (0, a.default)((0, m.default)(r, (n == null ? void 0 : n.htmlparser2) || f), n) : [];
  }
})(s);
const $ = /* @__PURE__ */ p(s);
export {
  $ as default
};
